import { type FC } from 'react';
import { Button } from '@zawarski/eti-ui';
import { cn } from '@/lib/utils';

const appTitle = import.meta.env.VITE_APP_TITLE ?? 'Palmetto Check In/Out';

const PortalRedirect: FC = () => {
  return (
    <div className={'relative block h-screen'}>
      {window.location.href.indexOf('id_token') === -1 ? (
        <div className='bg-background flex h-full w-full flex-col items-center justify-center overflow-hidden'>
          {window.location.href.indexOf('id_token') === -1 ? (
            <div
              className={cn(
                'flex h-[400px] max-w-[400px] flex-col items-center justify-center rounded-lg p-6 shadow-lg shadow-[rgba(0,0,0,0.4)]',
                'bg-muted text-muted-foreground'
              )}>
              <div className='flex h-[150px] items-center justify-center'>
                <img
                  className='h-[86px] w-[86px] object-contain'
                  src='/images/launcher.png'
                  alt='Palmetto Logo'
                />
              </div>
              <div className='text-foreground text-2xl'> {appTitle} </div>
              <div className='text-foreground h-[50px] pt-4 text-center text-sm'>
                Please use the Portal to access this site.
              </div>
              <Button
                onClick={() => {
                  window.location.href = 'https://portal.palmettoeoc.com';
                }}>
                NAVIGATE TO PORTAL
              </Button>
              <div className='px-6 pt-6 text-center text-sm'>
                Access to this site is now available only through the portal at:
              </div>
              <div className='cursor-pointer pt-1 pb-6 text-sm text-(--primary)/80'>
                <a target='_blank' rel='noopener noreferrer' href='https://portal.palmettoeoc.com'>
                  portal.palmettoeoc.com
                </a>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
      <div
        className={
          'bg-muted text-muted-foreground absolute bottom-1 w-full p-2 text-center text-xs'
        }>
        All data in Palmetto is to be considered FOUO and not for public dissemination.
      </div>
    </div>
  );
};
export default PortalRedirect;
